import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
import { CarrotTypes } from "@shared/services/event_tracking/carrot_tracking";
interface CarrotShoppableUnitProductEntityParams {
  interaction_id: string;
  product_line_id;
}

export class CarrotShoppableUnitProductEntity extends BaseEntityClass {
  click_interaction_id: string;
  product_line_id: number;

  constructor(params: CarrotShoppableUnitProductEntityParams) {
    super();
    this.type = CarrotTypes.ShoppableUnitProduct;
    this.entity_version = 2;
    this.click_interaction_id = params.interaction_id;
    this.product_line_id = params.product_line_id;
  }
}
